import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { makeSelectFurniture } from '../Configurator/selectors/furniture';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import CabinetDescription from '../Description/CabinetDescription';
import { requestGet } from '../../utils/requests';
import { CABINET_URL } from '../Configurator/constants/furniture';
import { CabinetJson } from '../../lib/modelBuilder/Data';
import {
  StyledTabularContainer,
  StyledTabularDataRow,
} from '../../components/styles/StyledTabular';
// import styled from 'styled-components';

interface StateProps {
  furniture: Furniture | null;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  furniture: makeSelectFurniture(),
});

const PackagingInfos = () => {
  const { t } = useTranslation();
  const { furniture } = useSelector(stateSelector);

  const [packaging, setPackaging] = useState<string[]>([]);

  const getPackaging = () => {
    if (
      furniture &&
      furniture?.cabinets[0] &&
      furniture?.cabinets[0].cabinet.reference
    ) {
      const url = `${CABINET_URL}/${furniture?.cabinets[0].cabinet.reference}/packaging/`;
      (requestGet(url) as Promise<any>).then((response: any) => {
        // setPackaging(JSON.stringify(response, null, '\t'));
        setPackaging(response);
      });
    }
  };

  return (
    <div id="description-furniture" className="mt-5 mx-4 ">
      <div className="text-2xl my-2">{t('Packaging')}</div>

      <div className="my-2">
        Reference : {furniture?.cabinets[0].cabinet.reference}
      </div>

      <button
        onClick={getPackaging}
        className={`py-1 px-4 border  text-gray-800`}
      >
        {t('Get Infos')}
      </button>

      {packaging && (
        <StyledTabularContainer>
          {packaging.map((e: any) => (
            <StyledTabularDataRow>{e}</StyledTabularDataRow>
          ))}
        </StyledTabularContainer>
      )}
    </div>
  );
};

export default PackagingInfos;
